import ic_apps from '../../images/icons8-squared-menu-24.png'

function Footer() {
    return (
        <footer className="footer d-flex align-items-center border-top">
            <div className="container-fluid d-flex flex-wrap justify-content-between align-items-center">
                <div className="col-md-4 mb-0 d-flex align-items-center">
                    <a href={process.env.REACT_APP_AUTH_URL}>
                        <img
                            src={ic_apps}
                            width={24}
                            height={24}
                            alt=""
                            className='mr-2'
                        />
                    </a>
                    <h6 className='flex-grow-1 text-left mb-0'>All Service</h6>
                </div>

                {/* <a href="/" className="col-md-4 d-flex align-items-center justify-content-center mb-3 mb-md-0 me-md-auto link-dark text-decoration-none">
                  
                    
                </a> */}
                <p className="text-muted col-md-4 d-flex align-items-center justify-content-center mb-3 mb-md-0 me-md-auto ">
                    © สงวนลิขสิทธิ์ 2564 บริษัท ไทยเบฟเวอเรจ จำกัด (มหาชน)
                </p>

                <ul className="nav col-md-4 justify-content-end">
                    {/* <li className="nav-item"><a href="#" className="nav-link px-2 text-muted">Home</a></li>
                    <li className="nav-item"><a href="#" className="nav-link px-2 text-muted">Features</a></li>
                    <li className="nav-item"><a href="#" className="nav-link px-2 text-muted">Pricing</a></li>
                    <li className="nav-item"><a href="#" className="nav-link px-2 text-muted">FAQs</a></li>
                    <li className="nav-item"><a href="#" className="nav-link px-2 text-muted">About</a></li> */}
                </ul>

            </div>
        </footer>
    )
}
export default Footer;